import React, { FC, ReactElement } from 'react'
import SelectInput, { Props } from '../../../../React/Common/Components/Selects/SelectInput/SelectInput'

export const OutlinedSelectInput: FC<Props> = ({ ...props }: Props): ReactElement => (
    <div className='outlined-select-input'>
        <SelectInput {...props} optionsClassName='outlined-select-input-options' variant='outlined' />
    </div>
)
